import Vue from 'vue';

import store from '../external_landing_form/store';

import ExternalLandingFormApp from '../external_landing_form/app';

import FormHeader from '../external_landing_form/components/FormHeader';
import TextInput from '../external_landing_form/components/TextInput';
import BaseButton from '../external_landing_form/components/BaseButton';
import CheckboxInput from '../external_landing_form/components/CheckboxInput';
import ErrorWrapper from '../external_landing_form/components/ErrorWrapper';
import RegistrationForm from '../external_landing_form/components/RegistrationForm';
import TelInput from '../external_landing_form/components/TelInput';
import SmallHr from '../external_landing_form/components/SmallHr';
import { VueSelect } from 'vue-select';
import SimpleSpinner from 'vue-simple-spinner';
import Lottie from 'vue-lottie';

import OauthIcon from '@shared/components/OauthIcon';
import OauthLinks from '@shared/components/OauthLinks';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faAt, faUser, faCheck, faTimes, faArrowLeft, faArrowRight, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle, faCreditCard, faCalendarTimes } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';

library.add(faAt, faUser, faCheck, faTimes, faCheckCircle, faCreditCard, faArrowLeft, faArrowRight, faCalendarTimes, faExternalLinkAlt);

import 'intl-tel-input/build/css/intlTelInput.min.css';

import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';
import customDictionary from '../external_landing_form/custom_dictionary';

window.OMNIAUTH_MODE = 'EXTERNAL_LANDING';

document.addEventListener('DOMContentLoaded', () => {
  Vue.use(VeeValidate);
  Validator.localize('ru', customDictionary);

  Vue.component('FormHeader', FormHeader);
  Vue.component('TextInput', TextInput);
  Vue.component('CheckboxInput', CheckboxInput);
  Vue.component('BaseButton', BaseButton);
  Vue.component('ErrorWrapper', ErrorWrapper);
  Vue.component('RegistrationForm', RegistrationForm);
  Vue.component('TelInput', TelInput);
  Vue.component('SmallHr', SmallHr);
  Vue.component('FaIcon', FontAwesomeIcon);
  Vue.component('FaLayers', FontAwesomeLayers);
  Vue.component('VueSelect', VueSelect);
  Vue.component('SimpleSpinner', SimpleSpinner);
  Vue.component('Lottie', Lottie);
  Vue.component('OauthIcon', OauthIcon);
  Vue.component('OauthLinks', OauthLinks);

  const appWrapper = document.getElementById('form_app');

  if (!appWrapper) return;

  const appContainer = document.createElement('div');

  appWrapper.innerHTML = '';
  appWrapper.appendChild(appContainer);

  new Vue({
    store,
    el: appContainer,
    components: { ExternalLandingFormApp },
    template: '<ExternalLandingFormApp/>',
  });

  store.dispatch('initialize');
});
